<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-md-offset-3">
        <div class="login-panel panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Подтверждение личности</h3>
          </div>
          <div class="panel-body">
            <div class="panel-body__wrapper">
              <p class="panel-body__text">
                Пожалуйста, {{ user.login }}, покажите своё лицо для
                подтверждения личности
              </p>
              <Preloader
                v-if="!webcamStream"
                class="panel-body__preloader"
                type="small"
              />
              <div v-show="webcamStream" class="panel-body__webcam">
                <video ref="webcam" muted class="webcam__video"></video>
              </div>
              <button
                type="button"
                class="btn btn-danger btn-block"
                @click="returnToLoginForm"
                :disabled="!webcamStream || isSuccess || wasCancelled"
              >
                Вернуться обратно
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <canvas id="snapshotCanvas" width="740" height="460" />
  </div>
</template>

<script>
import Preloader from "@/_shared/components/ui/Preloader";
import router from "@/_shared/router";
import apiService from "@/authorization/apiService";
import { useNotification } from "@/_shared/mixins";
import { useWebcam, useFaceRecognition } from "@/authorization/mixins";
export default {
  mixins: [useNotification, useFaceRecognition, useWebcam],
  components: {
    Preloader,
  },
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      wasCancelled: false,
      isSuccess: false,
      attempts: 7,
    };
  },
  mounted() {
    this.$nextTick(this.enableWebcam);
  },
  methods: {
    async authSuccess() {
      if (this.wasCancelled) {
        return;
      }
      this.isSuccess = true;
      await apiService
        .login(this.user, null, this.makeSnapshot())
        .then((loggedToday) => {
          const message = `Добро пожаловать, ${this.user.login}!`;
          this.showSuccessNotification(message);
          // if (loggedToday === false) {
          //   setTimeout(() => {
          //     const notice = 'Не забудьте начать рабочую смену!';
          //     this.showStandardNotification(notice, 4000);
          //   }, 1500);
          // }
        })
        .then(this.leaveForm)
        .catch(({ response }) => {
          this.showErrorNotification(response.data.message);
        });
    },
    async authFailed() {
      if (this.wasCancelled) {
        return;
      }
      if (this.attempts === 0) {
        this.wasCancelled = true;
        const callback = () => this.leaveForm(true, 3500);
        const message = "Лицо не распознано";
        await this.addFailure(message, callback);
        return;
      }
      this.attempts -= 1;
      const message =
        `Либо вы не являетесь ${this.user.login}, ` +
        `либо при распознавании лица возникла ошибка.`;
      this.showErrorNotification(message);
    },
    async returnToLoginForm() {
      this.wasCancelled = true;
      const callback = () => {
        setTimeout(() => {
          this.disableWebcam();
          this.$emit("webcam-was-disabled");
        }, 3500);
      };
      await this.addFailure("Форма была покинута", callback);
    },
    async addFailure(reason, leaveCallback) {
      const body = {
        failure_reason: reason,
        user: this.user,
        snapshot: this.makeSnapshot(),
      };
      await apiService.addFailure(body).then((results) => {
        this.showErrorNotification(results.message, "Ошибка");
        leaveCallback();
      });
    },
    leaveForm(withFailure = false, transitionDuration = 1500) {
      setTimeout(() => {
        this.disableWebcam();
        withFailure ? router.go() : router.push("/");
      }, transitionDuration);
    },
  },
};
</script>

<style scoped>
#snapshotCanvas {
  opacity: 0;
}
.panel-body__preloader {
  margin: 4em 0;
}
.panel-body__webcam {
  display: inline-block;
}
.panel-body__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 1em;
  margin: 1em auto;
}
.panel-body__text {
  text-align: center;
}
.webcam__video {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/authorization/components/FaceRecognitionForm.vue